import { login } from "locales/en/login";
import { home } from "./home";
import { register } from "locales/en/register";
import { payment } from "locales/en/payment";
import { avoir } from "locales/en/avoir";
import { invoice } from "./invoice";
import { sidebar } from "./navItems";
import { offer } from "./offer";
import { app } from "./app";
import { supplier } from "./supplier";
import { client } from "./client";
import { depense } from "./depense";
import { quote } from "./quote";
import { role } from "./role";
import { users } from "./users";
import { signature } from "./signature";
import { ged } from "./ged";
import { contrats } from "./contrat";
import { alert } from "./alert";
import { projects } from "./project";
import { congeList } from "./congeList";
import { cra } from "./cra";
import { pack } from "./pack";
import { profile } from "./profile";

import { supplierConsult } from "./supplierConsult";
import { supplierUser } from "./supplierUser";
import { absences } from "./absences";
import { leaveRequest } from "./leaveRequest";
import { timesheet } from "./timesheet";

export const en = {
  home: home,
  login: login,
  register: register,
  payment: payment,
  avoir: avoir,
  invoice: invoice,
  sidebar: sidebar,
  offer: offer,
  app: app,
  supplier: supplier,
  client: client,
  depense: depense,
  quote: quote,
  role: role,
  users: users,
  signature: signature,
  ged: ged,
  contrats: contrats,
  alert,
  projects: projects,
  congeList: congeList,
  cra,
  pack,
  profile,

  supplierConsult: supplierConsult,
  supplierUser: supplierUser,
  absences: absences,
  leaveRequest: leaveRequest,
  timesheet: timesheet,
};
